import { FaInstagramSquare } from "react-icons/fa";

import SlidingImages from "../../components/SlidingImages";
import RightArrow from "../../assets/images/png/rightArrow.png";

import CONSTANTS from "../../utils/constants/CONSTANTS";
import { eventTrack, eventTrackGA4 } from "../../utils/helperFunctions";

import "./index.scss";

const InstagramFeed = () => {
  const handleInstaEvent = () => {
    eventTrack("Redirection To Instagram", "From instagram section", "Redirection");
    eventTrackGA4("Redirection To Instagram", "From instagram section", "Redirection");
  };
  return (
    <div className="instagram-feed">
      <div className="heading">
        <a target="_blank" href="https://www.instagram.com/omniactivefitness/" onClick={handleInstaEvent}>
          Check Us Out On Instagram
        </a>
      </div>
      <div className="insta-icons">
        <div className="icon-container" style={{ fontSize: "80px" }}>
          <a target="_blank" href="https://www.instagram.com/omniactivefitness/" onClick={handleInstaEvent}>
            <FaInstagramSquare className="insta-icon" />
          </a>
        </div>
        <div className="right-arrow">
          <img className="arrow-icon" src={RightArrow} alt="right arrow" />
        </div>
      </div>
      <div className="insta-images">
        <SlidingImages
          images={CONSTANTS.instagramFeed}
          imageType={CONSTANTS.instaWidth}
          imageAnimation={CONSTANTS.instagramAnimation}
        />
      </div>
      <div className="insta-images">
        <SlidingImages
          images={CONSTANTS.instagramFeedTwo}
          imageType={CONSTANTS.instaWidth}
          imageAnimation={CONSTANTS.instagramAnimation}
        />
      </div>
    </div>
  );
};
export default InstagramFeed;
